module.exports = __webpack_public_path__ + "static/media/WhenYouWishUponaLanternBookCover.b83a0a33.jpg";